import { useMutation, useQueryClient } from "@tanstack/react-query";
import Cookies from "universal-cookie";
import { COMPANY_ID, TOKEN_NAME, PRODUCT_SLUG } from "../../config";
import axios from "../../api/axios";
const cookies = new Cookies();

const usePut = ({ url, onSuccess, onError, refreshUrl, passCompanyId = true }) => {
  const queryClient = useQueryClient();
  const handleAuth = useMutation({
    mutationFn: (data) => handleFormSubmit(data),
    onSuccess: (data) => {
      onSuccess?.(data);
      if (refreshUrl) {
        if (Array.isArray(refreshUrl)) {
          refreshUrl.forEach((u) => queryClient.invalidateQueries([u]));
        } else {
          queryClient.invalidateQueries([refreshUrl]);
        }
      }
    },
    onError: (err) => {
      onError?.(err);
    },
  });
  const handleFormSubmit = async (getFormData) => {
    let token = cookies.get(TOKEN_NAME);
    let fd = new FormData();
    if (passCompanyId) {
      fd.append("company_id", cookies.get(COMPANY_ID));
    }
    fd.append("product_slug", PRODUCT_SLUG);
    for (var key in getFormData) {
      if (
        Array.isArray(getFormData[key]) ||
        typeof getFormData[key] === "object"
      ) {
        fd.append(key, JSON.stringify(getFormData[key]));
      } else {
        fd.append(key, getFormData[key]);
      }
    }

    const response = await axios({
      method: "POST",
      url: `/${url}`,
      data: fd,
      headers: { Authorization: token ? `Bearer ${token}` : "" },
    });
    return response;
  };
  return { handleAuth };
};

export default usePut;
